import { render } from "./GamesReviews.vue?vue&type=template&id=3d147681&scoped=true"
import script from "./GamesReviews.vue?vue&type=script&lang=js"
export * from "./GamesReviews.vue?vue&type=script&lang=js"

import "./GamesReviews.vue?vue&type=style&index=0&id=3d147681&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d147681"]])

export default __exports__